import { useTranslation } from 'react-i18next';
import { ToggleSwitch } from 'Components/common/ToggleSwitch';
import styled from 'styled-components';

const Card = styled.div`
  background: white;
  border-radius: 14px;
  padding: 24px;
  box-shadow: 0 1px 3px var(--vo-escuro-8);
`;

const CardTitle = styled.p`
  font-family: 'Rubik', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: var(--vo-ink);
  margin: 0 0 4px;
`;

const CardSubtitle = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 13px;
  color: var(--vo-slate);
  margin: 0 0 16px;
`;

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background: var(--vo-mist);
  border-radius: 10px;
`;

const ToggleLeft = styled.div``;

const RowLabel = styled.p`
  font-family: 'Maven Pro', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--vo-ink-2);
  margin: 0 0 2px;
`;

const RowSubtext = styled.p`
  font-family: 'Lato', sans-serif;
  font-size: 12px;
  color: var(--vo-slate);
  margin: 0;
`;

export const CardConfigScan = ({ id, disclaimerMonthlySchedule, mutationMonthlySchedule }) => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card>
      <CardTitle>{t('cookies:show.scan.title')}</CardTitle>
      <CardSubtitle>{t('cookies:show.scan.subtitle')}</CardSubtitle>
      <ToggleRow>
        <ToggleLeft>
          <RowLabel>{t('cookies:show.scan.monthlyLabel')}</RowLabel>
          <RowSubtext>{t('cookies:show.scan.monthlySubtext')}</RowSubtext>
        </ToggleLeft>
        <ToggleSwitch
          checked={disclaimerMonthlySchedule}
          onChange={() => mutationMonthlySchedule.mutate(id)}
          disabled={mutationMonthlySchedule.isLoading}
        />
      </ToggleRow>
    </Card>
  );
};
